import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Stack, styled, Typography } from "~/common/mui";
import { EMAIL_SENT } from "~/utils/url/staticResources";

const ResetSuccessContent: FC = () => {
  const { t } = useTranslation();

  return (
    <StyledStack>
      <Box component="img" src={EMAIL_SENT} alt={t("sent.email.alt.text")} />
      <Stack gap={2}>
        <Typography variant="headlineMedium" sx={{ color: "textPrimary" }}>
          {t("reset.success.heading")}
        </Typography>

        <Typography variant="bodyLarge" sx={{ color: "textSecondary" }}>
          {t("reset.success.subHeading")}
        </Typography>
      </Stack>
    </StyledStack>
  );
};

export default ResetSuccessContent;

export const StyledStack = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: theme.spacing(3),
  maxWidth: "480px",
  height: "calc(100dvh - 80px)",
}));
